import { RouterProvider } from 'react-router-dom'
import { useRoutersData } from './routers'

export function Router() {
    const { router } = useRoutersData()
    return <RouterProvider router={router} />
}
